import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { stateRequiresWasteStreamRegistration } from "encamp-shared/src/waste/constants";

import { useFeatureFlags } from "./useFeatureFlags";

/**
 * Whether waste-stream state-registration fields, columns, and filters should
 * render for a facility in the given state. Gated behind both the
 * `WasteStateRegistration` feature flag and the facility being in a state that
 * requires waste-stream registration.
 */
export function useShowWasteStateRegistration(state: string | null | undefined): boolean {
  const { featureFlags } = useFeatureFlags();
  return (
    featureFlags[FeatureFlagKey.WasteStateRegistration] &&
    stateRequiresWasteStreamRegistration(state)
  );
}

/**
 * Flag-only variant for cross-facility surfaces (e.g. the tenant-wide waste
 * streams grid) where there is no single facility state to gate on. Rows whose
 * facility is outside the regulated set simply render blank registration
 * cells; the server returns the fields regardless.
 */
export function useWasteStateRegistrationEnabled(): boolean {
  const { featureFlags } = useFeatureFlags();
  return featureFlags[FeatureFlagKey.WasteStateRegistration];
}
